import React from "react";
import { FormikProps } from "formik";
import { SimulatorTextField } from "../fields/SimulatorTextField";
import { FormValues } from "../types";

interface InvoiceDataSectionProps {
  formik: FormikProps<FormValues>;
  changeContractTypeWithDemandaPonta: (e: any) => void;
  changeContractTypeWithDemandaForaPonta: (e: any) => void;
  resetDiscountWithUltrapassagemPontaType: (e: any) => void;
  resetDiscounWithtUltrapassagemForaPontaType: (e: any) => void;
}

export const InvoiceDataSection = ({
  formik,
  changeContractTypeWithDemandaPonta,
  changeContractTypeWithDemandaForaPonta,
  resetDiscountWithUltrapassagemPontaType,
  resetDiscounWithtUltrapassagemForaPontaType,
}: InvoiceDataSectionProps) => (
  <>
    <div>
      <span className="simulacao-form-header">Dados da fatura</span>
      <hr />
    </div>

    <div className="formLine">
      <SimulatorTextField
        formik={formik}
        name="demandaPonta"
        label="Demanda Contratada Ponta"
        placeholder="Em KW"
        unit="kW"
        disabled={formik.values.ths === "VERDE"}
        onChange={(e: any) => changeContractTypeWithDemandaPonta(e)}
        required
      />

      <SimulatorTextField
        formik={formik}
        name="demandaPontaUltrapassagem"
        label="Demanda Ponta Ultrapassagem"
        placeholder="Em KW"
        unit="kW"
        disabled={formik.values.ths === "VERDE"}
        onChange={(e: any) => resetDiscountWithUltrapassagemPontaType(e)}
        required
      />

      <SimulatorTextField
        formik={formik}
        name="consumoPonta"
        label={
          <>
            Consumo Ponta <span>*</span>
          </>
        }
        placeholder="Em kWh"
        unit="kWh"
        required
      />
    </div>

    <div className="formLine">
      <SimulatorTextField
        formik={formik}
        name="demandaForaPonta"
        label={
          <>
            Demanda Contratada Fora de Ponta <span>*</span>
          </>
        }
        placeholder="Em kW"
        unit="kW"
        onChange={(e: any) => changeContractTypeWithDemandaForaPonta(e)}
        required
      />

      <SimulatorTextField
        formik={formik}
        name="demandaForaPontaUltrapassagem"
        label="Demanda Fora de Ponta Ultrapassagem"
        placeholder="Em kW"
        unit="kW"
        onChange={(e: any) => resetDiscounWithtUltrapassagemForaPontaType(e)}
        required
      />

      <SimulatorTextField
        formik={formik}
        name="consumoForaPonta"
        label={
          <>
            Consumo Fora de Ponta <span>*</span>
          </>
        }
        placeholder="Em kWh"
        unit="kWh"
        required
      />
    </div>
  </>
);
